import { Pipe, PipeTransform } from '@angular/core';
import { PreferenceService } from '../../services/preference.service';

@Pipe({
  name: 'temperature',
})
export default class TemperaturePipe implements PipeTransform {
  constructor(private preferenceService: PreferenceService) {}

  transform(value: number | string) {
    if (this.preferenceService.$currentLang() === 'en') {
      if (value === undefined) return '--°F';

      return (Number(value) * 1.8 + 32).toFixed(2) + '°F';
    } else {
      if (value === undefined) return '--°C';

      return Number(value).toFixed(2) + '°C';
    }
  }
}
